import { Component } from '@angular/core';

@Component({
  selector: 'app-forum-index',
  templateUrl: './forum-index.component.html',
  styleUrls: ['./forum-index.component.scss']
})
export class ForumIndexComponent {

}
